<div class="students-page">
  <div class="students-card">

    <header class="students-header">
      <div class="header-text-block">
        <span class="eyebrow">Gestión de voluntarios</span>

        <h1>Voluntarios</h1>

        <p>
          Consulta la información registrada de las personas que colaboran con ABAQ.
        </p>
      </div>

      <!-- Botón: Ver Voluntarios Pasados (Fase D.1) -->
      <button
        type="button"
        class="btn-view-history"
        [routerLink]="['/volunteers/history']"
        title="Ver el historial de voluntarios pasados y la bitácora"
      >
        <span class="material-symbols-outlined">history</span>
        <span>Ver Voluntarios Pasados</span>
      </button>

      <!-- Botón Dropdown: Invitar a voluntarios -->
      <div class="invite-dropdown-wrap" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="btn-invite-volunteers"
          (click)="toggleInviteDropdown()"
          [attr.aria-expanded]="isInviteDropdownOpen"
          aria-haspopup="true"
          title="Compartir enlaces para registro o acceso de voluntarios"
        >
          <span class="material-symbols-outlined invite-btn-icon">person_add</span>
          <span>Invitar a voluntarios</span>
          <span class="material-symbols-outlined invite-arrow-icon" [class.rotated]="isInviteDropdownOpen">
            expand_more
          </span>
        </button>

        @if (isInviteDropdownOpen) {
          <div class="invite-dropdown-menu" role="menu">
            <div class="dropdown-menu-header">
              <div class="dropdown-header-top">
                <span class="material-symbols-outlined dropdown-header-icon">link</span>
                <span class="dropdown-menu-title">Enlaces de invitación</span>
              </div>
              <span class="dropdown-menu-subtitle">Haz clic en cualquier opción para copiar su enlace al portapapeles</span>
            </div>

            <div class="dropdown-menu-items">
              <!-- Opción 1: Link de registro para voluntarios (General) -->
              <button
                type="button"
                class="dropdown-item-btn"
                (click)="copyInviteLink('general')"
                [class.copied]="copiedKey === 'general'"
              >
                <div class="item-icon-box icon-general">
                  <span class="material-symbols-outlined">how_to_reg</span>
                </div>
                <div class="item-text-box">
                  <div class="item-title-row">
                    <span class="item-title">Link de registro para voluntarios</span>
                    <span class="item-tag-pill pill-general">General</span>
                  </div>
                  <span class="item-desc">Abre la pantalla de registro para elegir Servicio Social o Voluntariado General</span>
                  <code class="item-url-preview">{{ getFullUrl('/auth/signup') }}</code>
                </div>
                <div class="item-copy-status">
                  @if (copiedKey === 'general') {
                    <span class="copy-pill copied">
                      <span class="material-symbols-outlined text-xs">check</span>
                      ¡Copiado!
                    </span>
                  } @else {
                    <span class="copy-pill">
                      <span class="material-symbols-outlined text-xs">content_copy</span>
                      Copiar
                    </span>
                  }
                </div>
              </button>

              <div class="dropdown-section-divider">
                <span>Enlaces directos por rol</span>
              </div>

              <!-- Opción 2: Registro Voluntariado General (VG) -->
              <button
                type="button"
                class="dropdown-item-btn"
                (click)="copyInviteLink('vg')"
                [class.copied]="copiedKey === 'vg'"
              >
                <div class="item-icon-box icon-vg">
                  <span class="material-symbols-outlined">volunteer_activism</span>
                </div>
                <div class="item-text-box">
                  <div class="item-title-row">
                    <span class="item-title">Registro Voluntariado General</span>
                    <span class="item-tag-pill pill-vg">VG</span>
                  </div>
                  <span class="item-desc">Enlace directo con el rol Voluntario General preseleccionado</span>
                  <code class="item-url-preview">{{ getFullUrl('/auth/signup?type=VG') }}</code>
                </div>
                <div class="item-copy-status">
                  @if (copiedKey === 'vg') {
                    <span class="copy-pill copied">
                      <span class="material-symbols-outlined text-xs">check</span>
                      ¡Copiado!
                    </span>
                  } @else {
                    <span class="copy-pill">
                      <span class="material-symbols-outlined text-xs">content_copy</span>
                      Copiar
                    </span>
                  }
                </div>
              </button>

              <!-- Opción 3: Registro Servicio Social (SS) -->
              <button
                type="button"
                class="dropdown-item-btn"
                (click)="copyInviteLink('ss')"
                [class.copied]="copiedKey === 'ss'"
              >
                <div class="item-icon-box icon-ss">
                  <span class="material-symbols-outlined">school</span>
                </div>
                <div class="item-text-box">
                  <div class="item-title-row">
                    <span class="item-title">Registro Servicio Social</span>
                    <span class="item-tag-pill pill-ss">SS (480 hrs)</span>
                  </div>
                  <span class="item-desc">Enlace directo con el rol Servicio Social preseleccionado</span>
                  <code class="item-url-preview">{{ getFullUrl('/auth/signup?type=SS') }}</code>
                </div>
                <div class="item-copy-status">
                  @if (copiedKey === 'ss') {
                    <span class="copy-pill copied">
                      <span class="material-symbols-outlined text-xs">check</span>
                      ¡Copiado!
                    </span>
                  } @else {
                    <span class="copy-pill">
                      <span class="material-symbols-outlined text-xs">content_copy</span>
                      Copiar
                    </span>
                  }
                </div>
              </button>

              <div class="dropdown-section-divider">
                <span>Acceso de usuarios</span>
              </div>

              <!-- Opción 4: Link de Login -->
              <button
                type="button"
                class="dropdown-item-btn"
                (click)="copyInviteLink('login')"
                [class.copied]="copiedKey === 'login'"
              >
                <div class="item-icon-box icon-login">
                  <span class="material-symbols-outlined">login</span>
                </div>
                <div class="item-text-box">
                  <div class="item-title-row">
                    <span class="item-title">Link de Inicio de Sesión (Login)</span>
                    <span class="item-tag-pill pill-login">Acceso</span>
                  </div>
                  <span class="item-desc">Para voluntarios y estudiantes ya registrados previamente</span>
                  <code class="item-url-preview">{{ getFullUrl('/auth/login') }}</code>
                </div>
                <div class="item-copy-status">
                  @if (copiedKey === 'login') {
                    <span class="copy-pill copied">
                      <span class="material-symbols-outlined text-xs">check</span>
                      ¡Copiado!
                    </span>
                  } @else {
                    <span class="copy-pill">
                      <span class="material-symbols-outlined text-xs">content_copy</span>
                      Copiar
                    </span>
                  }
                </div>
              </button>
            </div>
          </div>
        }
      </div>
    </header>

    <div class="students-content">

      @if (actionMessage) {
        <div
          class="table-action-feedback"
          [class.is-error]="actionMessage.includes('Error')"
        >
          <span>{{ actionMessage }}</span>
        </div>
      }

      <div class="toolbar">

        <div class="search-box">
          <label for="table-filtering-search">
            Buscar voluntario
          </label>

          <input
            id="table-filtering-search"
            class="form-control search-input"
            type="text"
            [formControl]="filter"
            placeholder="Folio, nombre, carrera, correo o teléfono..."
          />
        </div>

        <div class="filter-chips">
          <button
            type="button"
            class="filter-chip"
            [class.active]="!showPendingOnly"
            (click)="setPendingFilter(false)"
          >
            Todos ({{ volunteerList.length }})
          </button>

          <button
            type="button"
            class="filter-chip chip-pending"
            [class.active]="showPendingOnly"
            (click)="togglePendingFilter()"
            title="Filtrar voluntarios que solicitan ingresar al servicio"
          >
            <span class="material-symbols-outlined chip-icon">how_to_reg</span>
            <span>Solicitan ingresar</span>
            @if (totalPendingCount > 0) {
              <span class="chip-badge">{{ totalPendingCount }}</span>
            }
          </button>
        </div>

        <div class="student-count">
          <span class="count-number">
            {{ filteredVolunteerList.length }}
          </span>

          <span class="count-label">
            {{
              filteredVolunteerList.length === 1
                ? 'voluntario'
                : 'voluntarios'
            }}
          </span>
        </div>

      </div>

      <nav class="vol-tabs" role="tablist">
        <button
          type="button"
          class="vol-tab"
          role="tab"
          [class.active]="activeTab === 'ss'"
          [attr.aria-selected]="activeTab === 'ss'"
          (click)="setTab('ss')"
        >
          Servicio Social
          <span class="vol-tab-count">{{ socialServiceCount }}</span>
        </button>

        <button
          type="button"
          class="vol-tab"
          role="tab"
          [class.active]="activeTab === 'general'"
          [attr.aria-selected]="activeTab === 'general'"
          (click)="setTab('general')"
        >
          Voluntariado General
          <span class="vol-tab-count">{{ generalVolunteerCount }}</span>
        </button>
      </nav>

      <div class="volunteer-groups">

        <!-- =========================================
             SERVICIO SOCIAL
        ========================================== -->
      
        @if (
          activeTab === 'ss' &&
          filteredVolunteerList.some(
            volunteer =>
              volunteer.volunteerType === 'SERVICE_SOCIAL'
          )
        ) {
      
          <section class="volunteer-group">
      
            <div class="volunteer-group-header">
      
              <div>
                <span class="group-eyebrow">
                  Voluntariado institucional
                </span>
      
                <h2>
                  Servicio Social
                </h2>
      
                <p>
                  Voluntarios que realizan su servicio social con ABAQ.
                </p>
              </div>
      
              <div class="group-header-badges">
                <button
                  type="button"
                  class="pending-chip-btn"
                  [class.is-zero]="pendingStudentsCount === 0"
                  [class.is-filtered]="showPendingOnly && pendingStudentsCount > 0"
                  (click)="togglePendingFilter()"
                  title="Filtrar solicitudes de ingreso"
                >
                  ⏳ {{ pendingStudentsCount }} {{ pendingStudentsCount === 1 ? 'pendiente de aceptación' : 'pendientes de aceptación' }}
                </button>

                <span class="group-count">
                  {{
                    filteredVolunteerList.filter(
                      volunteer =>
                        volunteer.volunteerType === 'SERVICE_SOCIAL'
                    ).length
                  }}
                  {{
                    filteredVolunteerList.filter(
                      volunteer =>
                        volunteer.volunteerType === 'SERVICE_SOCIAL'
                    ).length === 1
                      ? 'voluntario'
                      : 'voluntarios'
                  }}
                </span>
              </div>
      
            </div>
      
      
            <div class="table-wrapper">
      
              <table class="students-table">
      
                <thead>
                  <tr>
                    <th>Nombre completo</th>
                    <th>Carrera</th>
                    <th>Correo</th>
                    <th>Teléfono</th>
                    <th>Estado</th>
                    <th>Horas por acreditar</th>
                    <th>Horas validadas</th>
                    <th>Periodo</th>
                    <th class="actions-th">Acciones</th>
                  </tr>
                </thead>
      
                <tbody>
      
                  @for (
                    volunteer of pagedSocialServiceVolunteers;
                    track volunteer.volunteerType + '-' + volunteer.id
                  ) {
                    <tr
                      [class.row-pending]="volunteer.accountStatus === 'pending'"
                      [class.row-inactive]="volunteer.accountStatus === 'inactive' || volunteer.accountStatus === 'rejected'"
                    >
                        <td class="student-name">
                          {{ volunteer.fullName }}
                        </td>
      
                        <td>
                          {{ volunteer.career || '—' }}
                        </td>
      
                        <td>
                          {{ volunteer.mail || 'Sin correo' }}
                        </td>
      
                        <td class="phone-cell">
                          {{ volunteer.phone }}
                        </td>

                        <td class="status-cell">
                          @if (volunteer.accountStatus === 'pending') {
                            <span class="badge-status badge-pending">⏳ Pendiente</span>
                          } @else if (volunteer.accountStatus === 'rejected') {
                            <span class="badge-status badge-rejected">✕ Rechazado</span>
                          } @else if (volunteer.accountStatus === 'inactive') {
                            <span class="badge-status badge-inactive">⏹ Inactivo</span>
                          } @else {
                            <span class="badge-status badge-active">✓ Activo</span>
                          }
                        </td>
      
                        <td class="hours-cell">
                          {{ volunteer.desiredHours ?? 0 }}
                        </td>
      
                        <td class="hours-cell validated">
                          {{ volunteer.validatedHours ?? 0 }}
                        </td>
      
                        <td class="period-cell">
                          {{ volunteer.periodEnd | date }}
                        </td>
      
                        <td class="actions-cell">
      
                          @if (volunteer.accountStatus === 'pending') {
                            <div class="actions-decision-group">
                              <button
                                type="button"
                                class="btn-arrow-action btn-arrow-accept"
                                [disabled]="actionLoadingId === volunteer.id"
                                (click)="acceptVolunteerItem(volunteer, $event)"
                                title="Aceptar e ingresar estudiante"
                                aria-label="Aceptar ingreso"
                              >
                                <span class="material-symbols-outlined">check</span>
                              </button>

                              <button
                                type="button"
                                class="btn-arrow-action btn-arrow-reject"
                                [disabled]="actionLoadingId === volunteer.id"
                                (click)="rejectVolunteerItem(volunteer, $event)"
                                title="Rechazar solicitud de ingreso"
                                aria-label="Rechazar solicitud"
                              >
                                <span class="material-symbols-outlined">close</span>
                              </button>
                            </div>
                          } @else if (volunteer.accountStatus === 'active') {
                            <button
                              type="button"
                              class="btn-arrow-action btn-arrow-inactivate"
                              [disabled]="actionLoadingId === volunteer.id"
                              (click)="openInactivateModal(volunteer, $event)"
                              title="Inactivar cuenta por decisión administrativa"
                              aria-label="Inactivar cuenta"
                            >
                              <span class="material-symbols-outlined">person_off</span>
                            </button>
                          }

                          <button
                            type="button"
                            class="detail-button"
                            (click)="viewStudent(volunteer.id)"
                          >
                            Ver detalle
                          </button>
      
                        </td>
      
                      </tr>
      
                  }
      
                </tbody>
      
              </table>
      
            </div>

            <app-pagination
              [(page)]="ssPage"
              [totalItems]="socialServiceVolunteers.length"
              [pageSize]="ssPageSize"
            ></app-pagination>
      
          </section>
      
        }
      
      
        <!-- =========================================
             VOLUNTARIOS GENERALES
        ========================================== -->
      
        @if (
          activeTab === 'general' &&
          filteredVolunteerList.some(
            volunteer =>
              volunteer.volunteerType === 'GENERAL'
          )
        ) {
      
          <section class="volunteer-group general-group">
      
            <div class="volunteer-group-header">
      
              <div>
                <span class="group-eyebrow">
                  Voluntariado independiente
                </span>
      
                <h2>
                  Voluntarios Generales
                </h2>
      
                <p>
                  Personas que colaboran con ABAQ sin realizar servicio social.
                </p>
              </div>
      
              <div class="group-header-badges">
                <button
                  type="button"
                  class="pending-chip-btn"
                  [class.is-zero]="pendingGeneralCount === 0"
                  [class.is-filtered]="showPendingOnly && pendingGeneralCount > 0"
                  (click)="togglePendingFilter()"
                  title="Filtrar solicitudes de ingreso"
                >
                  ⏳ {{ pendingGeneralCount }} {{ pendingGeneralCount === 1 ? 'pendiente de aceptación' : 'pendientes de aceptación' }}
                </button>

                <span class="group-count">
                  {{
                    filteredVolunteerList.filter(
                      volunteer =>
                        volunteer.volunteerType === 'GENERAL'
                    ).length
                  }}
                  {{
                    filteredVolunteerList.filter(
                      volunteer =>
                        volunteer.volunteerType === 'GENERAL'
                    ).length === 1
                      ? 'voluntario'
                      : 'voluntarios'
                  }}
                </span>
              </div>
      
            </div>
      
      
            <div class="table-wrapper">
      
              <table class="students-table">
      
                <thead>
                  <tr>
                    <th>Nombre completo</th>
                    <th>Correo</th>
                    <th>Teléfono</th>
                    <th>Estado</th>
                    <th>Inicio de voluntariado</th>
                    <th class="actions-th">Acciones</th>
                  </tr>
                </thead>
      
                <tbody>
      
                  @for (
                    volunteer of pagedGeneralVolunteers;
                    track volunteer.volunteerType + '-' + volunteer.id
                  ) {
      
                      <tr
                        [class.row-pending]="volunteer.accountStatus === 'pending'"
                        [class.row-inactive]="volunteer.accountStatus === 'inactive' || volunteer.accountStatus === 'rejected'"
                      >
                        <td class="student-name">
                          {{ volunteer.fullName }}
                        </td>
      
                        <td>
                          {{ volunteer.mail || 'Sin correo' }}
                        </td>
      
                        <td class="phone-cell">
                          {{ volunteer.phone }}
                        </td>

                        <td class="status-cell">
                          @if (volunteer.accountStatus === 'pending') {
                            <span class="badge-status badge-pending">⏳ Pendiente</span>
                          } @else if (volunteer.accountStatus === 'rejected') {
                            <span class="badge-status badge-rejected">✕ Rechazado</span>
                          } @else if (volunteer.accountStatus === 'inactive') {
                            <span class="badge-status badge-inactive">⏹ Inactivo</span>
                          } @else {
                            <span class="badge-status badge-active">✓ Activo</span>
                          }
                        </td>
      
                        <td class="period-cell">
                          {{ volunteer.volunteerStartDate | date }}
                        </td>
      
                        <td class="actions-cell">
      
                          @if (volunteer.accountStatus === 'pending') {
                            <div class="actions-decision-group">
                              <button
                                type="button"
                                class="btn-arrow-action btn-arrow-accept"
                                [disabled]="actionLoadingId === volunteer.id"
                                (click)="acceptVolunteerItem(volunteer, $event)"
                                title="Aceptar e ingresar voluntario general"
                                aria-label="Aceptar voluntario"
                              >
                                <span class="material-symbols-outlined">check</span>
                              </button>

                              <button
                                type="button"
                                class="btn-arrow-action btn-arrow-reject"
                                [disabled]="actionLoadingId === volunteer.id"
                                (click)="rejectVolunteerItem(volunteer, $event)"
                                title="Rechazar solicitud de voluntario"
                                aria-label="Rechazar solicitud"
                              >
                                <span class="material-symbols-outlined">close</span>
                              </button>
                            </div>
                          } @else if (volunteer.accountStatus === 'active') {
                            <button
                              type="button"
                              class="btn-arrow-action btn-arrow-inactivate"
                              [disabled]="actionLoadingId === volunteer.id"
                              (click)="openInactivateModal(volunteer, $event)"
                              title="Inactivar cuenta por decisión administrativa"
                              aria-label="Inactivar cuenta"
                            >
                              <span class="material-symbols-outlined">person_off</span>
                            </button>
                          }

                          <button
                            type="button"
                            class="detail-button"
                            [routerLink]="[
                              '/volunteer-detail',
                              volunteer.id
                            ]"
                          >
                            Ver detalle
                          </button>
      
                        </td>
      
                      </tr>
      
                  }
      
                </tbody>
      
              </table>
      
            </div>

            <app-pagination
              [(page)]="generalPage"
              [totalItems]="generalVolunteers.length"
              [pageSize]="generalPageSize"
            ></app-pagination>
      
          </section>
      
        }
      
      </div>

    </div>

  </div>
</div>

<app-inactivate-volunteer-modal
  *ngIf="inactivatingTarget"
  [targetId]="inactivatingTarget.id"
  [targetName]="inactivatingTarget.name"
  [targetFolio]="inactivatingTarget.folio || ''"
  [targetRole]="inactivatingTarget.role"
  (confirmed)="handleInactivateConfirmed($event)"
  (cancelled)="closeInactivateModal()"
>
</app-inactivate-volunteer-modal>
